export const CoordinationParametersErrorMessages = {
    friendlies: {
        frnSearch: {
            notFound: (frns: string): string =>
                `The following FRNs were not found: ${frns}. Please check your entry and try again.`,
        },
        addCallSignOrULSFileNumber: {
            alreadyAdded: 'This call sign or ULS file number is already added.',
            invalidLength:
                'Identifier(s) too long. Please check your entry and try again.',
        },
    },
} as const;
